//@flow

import type {
  AdvancedShippingLocation,
  AdvancedLocationAdmin1,
  AdvancedLocationAdmin2,
  AdvancedLocationAdmin3,
} from '../../../../entities/logistic/delivery-method/advanced';
import type {DeliveryMethod} from '../../../../entities/logistic/delivery-method';
import {deepClone} from '../../../../utils/object/deep-clone';

export function mergeAdvancedShippingLocations(
  deliveryMethods: DeliveryMethod[]
): AdvancedShippingLocation {
  const locations: any[] = deepClone(deliveryMethods)
    .map(method =>
      method.type === 'store-shipping-method-advanced-admin-group'
        ? method.location
        : undefined
    )
    .filter(item => item !== undefined);
  const mergedLocation: AdvancedShippingLocation = {};

  locations.forEach(location => {
    Object.entries(location).forEach(([countryCode, admin1Data]) => {
      if (!mergedLocation[countryCode]) {
        mergedLocation[countryCode] = admin1Data;
      } else {
        mergedLocation[countryCode] = mergeAdmin1Data(
          mergedLocation[countryCode],
          admin1Data
        );
      }
    });
  });

  return mergedLocation;
}

function mergeAdmin1Data(
  target: AdvancedLocationAdmin1 | boolean,
  source: AdvancedLocationAdmin1 | boolean
): AdvancedLocationAdmin1 | boolean {
  if (typeof source === 'boolean') {
    return source;
  }
  if (typeof target === 'boolean') {
    return target;
  }

  Object.entries(source).forEach(([admin1Id, admin2Data]) => {
    if (!target[admin1Id]) {
      target[admin1Id] = admin2Data;
    } else {
      target[admin1Id] = mergeAdmin2Data(target[admin1Id], admin2Data);
    }
  });

  return target;
}

function mergeAdmin2Data(
  target: AdvancedLocationAdmin2 | boolean,
  source: AdvancedLocationAdmin2 | boolean
): AdvancedLocationAdmin2 | boolean {
  if (typeof source === 'boolean') {
    return source;
  }
  if (typeof target === 'boolean') {
    return target;
  }

  Object.entries(source).forEach(([admin2Id, admin3Data]) => {
    if (!target[admin2Id]) {
      target[admin2Id] = admin3Data;
    } else {
      target[admin2Id] = mergeAdmin3Data(target[admin2Id], admin3Data);
    }
  });

  return target;
}

function mergeAdmin3Data(
  target: AdvancedLocationAdmin3 | boolean,
  source: AdvancedLocationAdmin3 | boolean
): AdvancedLocationAdmin3 | boolean {
  if (typeof source === 'boolean') {
    return source;
  }
  if (typeof target === 'boolean') {
    return target;
  }

  Object.entries(source).forEach(([admin3Id, value]) => {
    target[admin3Id] = value;
  });

  return target;
}
